import { ThemeProvider } from '@mui/material/styles';
import { useRouteError } from 'react-router';
import { greycroftTheme } from '../../theme/material-custom';
import { GenericErrorFallback } from './GenericErrorFallback';

// Rendered as the root route's errorElement, i.e. outside the app's providers,
// so it must supply the theme itself or the fallback crashes on custom theme fields.
export function RouteErrorFallback() {
  const error = useRouteError();
  return (
    <ThemeProvider theme={greycroftTheme}>
      <GenericErrorFallback error={error} />
    </ThemeProvider>
  );
}
